export const SHOW_STOP_CARDS = '|A|SHOW_STOP_CARDS'
export const PEEK_STOP_CARDS = 'PEEK_STOP_CARDS'
export const LOWER_STOP_CARDS = 'LOWER_STOP_CARDS'
export const HIDE_STOP_CARDS = 'HIDE_STOP_CARDS'

export const showStopCards = () => {
    return {
        type: SHOW_STOP_CARDS,
    }
}

export const peekStopCards = () => {
    return {
        type: PEEK_STOP_CARDS,
    }
}

export const lowerStopCards = () => {
    return {
        type: LOWER_STOP_CARDS,
    }
}

export const hideStopCards = () => {
    return {
        type: HIDE_STOP_CARDS,
    }
}
